const Loader = () => {
  return <div className="loading-spinner"></div>;
};

export { Loader };
